/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.home-hero').fullScreen(true);
        $('.wpcf7-select').addClass('turnintodropdown');
        $(window).resize(function(){       
            $('.home-hero').fullScreen(true);

            

            if($(window).width() <= 1024){
          $('.squares').each(function() {
            var child = $(this).find('.squares-text-right');
            child.detach();
              $(this).prepend(child);
            });
          }else {
            $('.squares').each(function() {
            var child = $(this).find('.squares-text-right');
            child.detach();
              $(this).append(child);
            });
          }
        });

        $(window).resize(function(){  
          if($(window).width() > 768){
            jQuery('.nav-primary, .nav-toggle, .header').removeClass('expanded');
          }
        });


        $(window).load(function(){
          $('.loader').fadeOut(500);
         $('.container').fadeIn(500);
         $('.flexslider').flexslider({
              animation: "slide"
         });

          if($(window).width() <= 1024){
          $('.squares').each(function() {
            var child = $(this).find('.squares-text-right');
            child.detach();
              $(this).prepend(child);
            });
          }else {
            $('.squares').each(function() {
              console.log('squares');
            var child = $(this).find('.squares-text-right');
            child.detach();
              $(this).append(child);
            });
          }

        });

        // $('.open-menu img').click(function(e){
        //   e.preventDefault();
        //   var content = $(this).closest('.food-menu').find('.menu-content');
        //   if($(this).hasClass('rotated')) {
        //     content.slideToggle(500);
        //     $(this).removeClass('rotated');
        //     $(this).closest('.open-menu').find('.arrow-text').html('<p class="arrow-text">Open Menu</p>');
        //   } else {
        //     content.slideToggle(500);
        //     $(this).addClass('rotated');
        //     $(this).closest('.open-menu').find('.arrow-text').html('<p class="arrow-text">Close Menu</p>');
        //   }
        // });

        // $('.menu-button').click(function(){
        //   var str = $(this).attr('href').replace('#', '');
        //    $('.food-menu').each(function(){
        //     if($(this).attr('id') == str) {
        //       var content1 = $(this).find('.menu-content');
        //       if(content1.next('.open-menu').find('img').hasClass('rotated')) {
        //       }else{
        //       content1.slideToggle(500);
        //       $(this).find('.open-menu img').addClass('rotated');
        //       $(this).find('.open-menu').find('.arrow-text').html('<p class="arrow-text">Close Menu</p>');
        //       }
              
        //     }
        //   });
        // });

        $('#menu-item-429').hover(function(){
          $(this).find('.sub-menu').addClass('expanded');
        }, function() {
        $(this).find('.sub-menu').removeClass('expanded');
        });

        if($('div.banner-section').hasClass('no-image')) {
          $('div.banner-section').find('div.learn-more').hide();
         
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $(document).ready(function() {
        $('.home-hero video').height();
      });
        var video = $('.home-video video');
        video[0].bind('ended', function() {
          $('.play').fadeIn();
        });

        $('.play').click(function(){
          if(video[0].paused) {
            video[0].play();
            $('.play').fadeOut();
            }
            else {
                video[0].pause();
            }
            return false;
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
